export function assertNever(arg: never): void {
    throw new Error('An unexpected value was found: (' + typeof arg + ') ' + arg);
}
